export default __webpack_public_path__ + "static/media/VOLKSWAGEN.c0206ff5.jpeg";